import emptySplitApi from './services';

export default emptySplitApi.endpoints;
